import {
  ALLOWLIST_REQ,
  ALLOWLIST_SET,
  ALLOWLIST_REQ_SUCCESS,
  ALLOWLIST_REQ_ERROR,
  ALLOWLIST_CREATE_REQ,
  ALLOWLIST_UPDATE_REQ,
  ALLOWLIST_DELETE_REQ,
  ALLOWLIST_DETECTION_SET,
  ALLOWLIST_EDIT_COPY_SET,
  ALLOWLIST_EDIT_SET,
  THREAT_PROGRESSION_VIEW_PREFERENCES_REQ,
  SAVE_THREAT_PROGRESSION_VIEW_PREFERENCES,
  PRIVILEGED_ACTIVITIES_PREFERENCES_VIEW_REQ,
  SAVE_PRIVILEGED_ACTIVITIES_VIEW_PREFERENCES,
  ALLOWLIST_VIEW_PREFERENCES_REQ,
  SAVE_ALLOWLIST_VIEW_PREFERENCES
  // THREAT_PROGRESSION_PREFERENCES,
  // THREAT_PROGRESSION_CURRENT_USER_PREFERENCES,
  // THREAT_PROGRESSION_PREFERENCES_POST,
  // PRIVILEGED_ACTIVITIES_PREFERENCES,
  // PRIVILEGED_ACTIVITIES_CURRENT_USER_PREFERENCES,
  // PRIVILEGED_ACTIVITIES_PREFERENCES_POST,
  // ALLOWLIST_PREFERENCES,
  // ALLOWLIST_CURRENT_USER_PREFERENCES,
  // ALLOWLIST_PREFERENCES_POST

} from './rules.type'

import ApiRest from '@/api/api-rest'
import IQCollection from '@/resources/collections/IQCollection'
import { OrderByEnum } from '@/constants/orderby.constants'
import { allowlistMetaInfo } from '@/column-header/allowlist/allowlist-meta'

const state = {
  rulesAllowlist: {},
  rulesAllowlistReqStatus: '',
  selectedDetectionAllowlist: {},
  selectedEditedAllowlist: {},
  selectedCopiedAllowlist: {},
  lastEditedAllowlist: {},
  threatProgressionPreferences: [],
  privilegedActivitiesPreferences: [],
  allowlistPreferences: []
}

const getters = {
  rulesAllowlist: state => state.rulesAllowlist,
  rulesAllowlistReqStatus: state => state.rulesAllowlistReqStatus,
  selectedDetectionAllowlist: state => state.selectedDetectionAllowlist,
  selectedEditedAllowlist: state => state.selectedEditedAllowlist,
  selectedCopiedAllowlist: state => state.selectedCopiedAllowlist,
  lastEditedAllowlist: state => state.lastEditedAllowlist,
  threatProgressionPreferences: state => state.threatProgressionPreferences,
  privilegedActivitiesPreferences: state => state.privilegedActivitiesPreferences,
  allowlistPreferences: state => state.allowlistPreferences
}

// Best Practice - updates state
const mutations = {
  [ALLOWLIST_REQ]: (state, data) => {
    state.rulesAllowlistReqStatus = 'loading'
  },
  [ALLOWLIST_REQ_SUCCESS]: (state, data) => {
    state.rulesAllowlistReqStatus = 'saved'
  },
  [ALLOWLIST_REQ_ERROR]: (state, data) => {
    state.rulesAllowlistReqStatus = 'error'
  },
  [ALLOWLIST_SET]: (state, data) => {
    state.rulesAllowlist = data
  },
  [ALLOWLIST_DETECTION_SET]: (state, detection) => {
    state.selectedDetectionAllowlist = detection
  },
  [ALLOWLIST_EDIT_COPY_SET]: (state, { operation, allowlist }) => {
    switch (operation) {
      case 'copy':
        state.selectedCopiedAllowlist = _.cloneDeep(allowlist)
        state.selectedCopiedAllowlist.name = `${state.selectedCopiedAllowlist.name} Copy`
        break
      default:
        state.selectedEditedAllowlist = _.cloneDeep(allowlist)
    }
  },
  [ALLOWLIST_EDIT_SET]: (state, allowlist) => {
    state.lastEditedAllowlist = allowlist;
  },
  [THREAT_PROGRESSION_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.threatProgressionPreferences = data
  },
  [PRIVILEGED_ACTIVITIES_PREFERENCES_VIEW_REQ]: (state, data) => {
    state.privilegedActivitiesPreferences = data
  },
  [ALLOWLIST_VIEW_PREFERENCES_REQ]: (state, data) => {
    state.allowlistPreferences = data
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [THREAT_PROGRESSION_VIEW_PREFERENCES_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUserThreatProgressionsPrefs = data.find(pref => {
            return pref.tbl_id === 9 && pref.user_id === uid
          })
          context.commit(THREAT_PROGRESSION_VIEW_PREFERENCES_REQ, currUserThreatProgressionsPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_THREAT_PROGRESSION_VIEW_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [PRIVILEGED_ACTIVITIES_PREFERENCES_VIEW_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUserPrivilegedActivitiesPrefs = data.find(pref => {
            return pref.tbl_id === 10 && pref.user_id === uid
          })
          context.commit(PRIVILEGED_ACTIVITIES_PREFERENCES_VIEW_REQ, currUserPrivilegedActivitiesPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_PRIVILEGED_ACTIVITIES_VIEW_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [ALLOWLIST_VIEW_PREFERENCES_REQ] (context, uid) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .get('preferences')
        .then(({ data }) => {
          let currUserAllowlistPrefs = data.find(pref => {
            return pref.tbl_id === 11 && pref.user_id === uid
          })
          context.commit(ALLOWLIST_VIEW_PREFERENCES_REQ, currUserAllowlistPrefs.prefered_cols)
          resolve(data)
        })
    })
  },
  [SAVE_ALLOWLIST_VIEW_PREFERENCES] (context, payload) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('preferences', {
          userId: payload.userId,
          tblId: payload.tblId,
          preferedCols: payload.preferedCols
        })
        .then(resp => {
          resolve(resp)
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  
  [ALLOWLIST_REQ] (context) {
    return new Promise((resolve, reject) => {
      context.commit(ALLOWLIST_REQ)
      ApiRest()
        .get('/rules/allowlist')
        .then(({ data }) => {
          let allowlist = new IQCollection(
            data,
            { attributes: allowlistMetaInfo.meta.columns },
            { defaultSort: 'name', sortOrder: OrderByEnum.ASC }
          )
          context.commit(ALLOWLIST_SET, allowlist)
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(ALLOWLIST_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [ALLOWLIST_REQ_SUCCESS] (context) {
    context.commit(ALLOWLIST_REQ_SUCCESS)
  },
  [ALLOWLIST_CREATE_REQ] (context, { allowlist }) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .post('/rules/allowlist', {
          author: allowlist.author,
          name: allowlist.name,
          description: allowlist.description,
          type: allowlist.type,
          allowListType: allowlist.allowListType,
          conditions: allowlist.conditions,
          rules: allowlist.rules
        })
        .then(({ data }) => {
          resolve({})
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [ALLOWLIST_UPDATE_REQ] (context, { allowlistId, allowlist }) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .put(`/rules/allowlist/${allowlistId}`, {
          author: allowlist.author,
          name: allowlist.name,
          description: allowlist.description,
          type: allowlist.type,
          allowListType: allowlist.allowListType,
          conditions: allowlist.conditions,
          rules: allowlist.rules
        })
        .then(({ data }) => {
          allowlist.id = allowlistId;
          allowlist.author.fullname = `${allowlist.author.firstname} ${allowlist.author.lastname}`
          context.commit(ALLOWLIST_EDIT_SET, allowlist);
          resolve({})
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [ALLOWLIST_DELETE_REQ] (context, allowlistId) {
    return new Promise((resolve, reject) => {
      ApiRest()
        .delete(`/rules/allowlist/${allowlistId}`)
        .then(({ data }) => {
          resolve({})
        })
        .catch(errMsg => {
          reject(errMsg)
        })
    })
  },
  [ALLOWLIST_DETECTION_SET] (context, detection) {
    context.commit(ALLOWLIST_DETECTION_SET, detection)
  },
  [ALLOWLIST_EDIT_COPY_SET] (context, { operation, allowlist }) {
    context.commit(ALLOWLIST_EDIT_COPY_SET, { operation, allowlist })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/rules/allowlist.module.js